import { connect } from 'react-redux';
import { voteInPoll } from './redux/actionCreators';
import { canUserVoteInPoll } from './redux/selectors';
import { getIsMobile } from '../publicSession/selectors';
const mapStateToProps = (state, { deviation })=>({
        isMobile: getIsMobile(state),
        canVote: canUserVoteInPoll(state, deviation)
    });
const mapDispatchToProps = {
    onVote: voteInPoll
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=PollView.container.js.map